"use strict";
/** state: Experimental **/
/** family: Table **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var TableBody_1 = require("../TableBody");
var TableCell_1 = require("../TableCell");
var TableHead_1 = require("../TableHead");
var TableRow_1 = require("../TableRow");
var utils_1 = require("../utils");
var CLASS_NAME = 'i-table';
var TableBorders;
(function (TableBorders) {
    TableBorders["Bordered"] = "bordered";
    TableBorders["Borderless"] = "borderless";
    TableBorders["Default"] = "default";
})(TableBorders = exports.TableBorders || (exports.TableBorders = {}));
var Table = (function (_a) {
    var borders = _a.borders, children = _a.children, className = _a.className, dark = _a.dark, hover = _a.hover, id = _a.id, responsive = _a.responsive, restProps = __rest(_a, ["borders", "children", "className", "dark", "hover", "id", "responsive"]);
    var header = React.Children.toArray(children)[0];
    var headerRow;
    var headerCells;
    var mobileOptions;
    if (header && header.props) {
        headerRow = header.props.children;
        if (headerRow && headerRow.props) {
            headerCells = headerRow.props.children;
            if (headerCells && headerCells.length > 0) {
                mobileOptions = headerCells.map(function (cell) {
                    return cell.props.mobileView
                        ? cell.props.mobileView
                        : '';
                });
            }
        }
    }
    // findHeader row
    var headers = React.Children.map(children, function (child) {
        if (utils_1.isType(child, TableHead_1.TableHead)) {
            return child;
        }
    });
    var headersRow;
    var headersCells;
    if (headers && headers.length > 0) {
        var firstHeader = headers[0];
        headersRow = React.Children.map(firstHeader.props.children, function (child) {
            if (utils_1.isType(child, TableRow_1.TableRow)) {
                return child;
            }
        });
        headersCells = React.Children.map(headersRow[0].props.children, function (child) {
            if (utils_1.isType(child, TableCell_1.TableCell)) {
                return child;
            }
        });
    }
    return (React.createElement("table", __assign({ className: classNames(className, CLASS_NAME, 'table', {
            'table-bordered': borders === TableBorders.Bordered,
            'table-borderless': borders === TableBorders.Borderless,
            'table-dark': dark,
            'table-hover': hover,
            'table-responsive': responsive,
        }), id: id }, restProps), React.Children.map(children, function (child) {
        if (utils_1.isType(child, TableBody_1.TableBody)) {
            return React.cloneElement(child, {
                header: headersCells && headersCells.length > 1
                    ? headersCells
                    : undefined,
                mobileOptions: mobileOptions,
                tableId: id,
            });
        }
        else {
            return child;
        }
    })));
});
exports.Table = Table;
Table.Borders = TableBorders;
Table.Head = TableHead_1.TableHead;
Table.Body = TableBody_1.TableBody;
Table.Row = TableRow_1.TableRow;
Table.Cell = TableCell_1.TableCell;
//# sourceMappingURL=Table.js.map